<template>
  <div class="container">
    <div class="content">
      <h1 style="font-size: 40px">{{ from.userName }}</h1>
      <div style="margin-top: 20px; font-size: 20px; line-height: 20px">
        <i class="el-icon-user-solid"></i>
        {{ from.email }}
      </div>
      <el-divider></el-divider>
      <div style="width: 100%; display: flex">
        <div style="width: 50%">
          <div style="display: flex">
            <div style="width: 130px; text-align: right">用户名</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.userName"
                v-if="isEdit"
                style="margin-top: -20px"
              ></el-input>
              <span v-else>{{ from.userName }}</span>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">生日</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.brithday"
                v-if="isEdit"
                style="margin-top: -20px"
              ></el-input>
              <span v-else>{{ from.brithday }}</span>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">用户类型</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-select
                v-model="from.type"
                v-if="isEdit"
                style="margin-top: -20px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span v-else>{{ from._type }}</span>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">公司</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.org"
                v-if="isEdit"
                style="margin-top: -20px"
              ></el-input>
              <span v-else>{{ from.org }}</span>
            </div>
          </div>
          <div style="margin-top: 40px">
            <el-divider></el-divider>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">省</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-select
                v-model="from.sheng"
                v-if="isEdit"
                style="margin-top: -20px"
                placeholder="请选择"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in province"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span v-else>{{ getShengName(from.sheng) }}</span>
            </div>
          </div>

          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">市</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-select
                v-model="from.shi"
                v-if="isEdit"
                style="margin-top: -20px"
                placeholder="请选择"
                @change="cityChange"
              >
                <el-option
                  v-for="item in cityOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span v-else>{{ getShiName(from.shi) }}</span>
            </div>
          </div>

          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">区/县</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-select
                v-model="from.xian"
                v-if="isEdit"
                style="margin-top: -20px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in countyOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span v-else>{{ getXianName(from.xian) }}</span>
            </div>
          </div>

          <div style="margin-top: 40px">
            <el-divider></el-divider>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">邮箱</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.email"
                v-if="isEdit"
                style="margin-top: -20px"
              ></el-input>
              <span v-else>{{ from.email }}</span>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div style="width: 130px; text-align: right">电话</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.phone"
                v-if="isEdit"
                style="margin-top: -20px"
              ></el-input>
              <span v-else>{{ from.phone }}</span>
            </div>
          </div>
          <!-- 新增密码输入框，仅在编辑模式下显示 -->
          <div style="display: flex; margin-top: 20px" v-if="isEdit">
            <div style="width: 130px; text-align: right">密码</div>
            <div style="margin-left: 40px; font-weight: bold; color: #666">
              <el-input
                v-model="from.source"
                type="password"
                show-password
                placeholder="请输入新密码"
                style="margin-top: -20px"
              ></el-input>
            </div>
          </div>
        </div>

        <div class="avatar">
          <img src="@/assets/user.png" />
        </div>
      </div>

      <el-divider></el-divider>
    </div>
    <div style="text-align: center">
      <el-button style="width: 200px" v-if="!isEdit" @click="edit"
        >修改</el-button
      >
      <el-button style="width: 200px" type="primary" v-else @click="submit"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { $user } from "@/services/admin";
import { $user as $userInterface } from "@/services";
import province from "./data/province.json";
import county from "./data/county.json";
import city from "./data/city.json";
export default {
  data() {
    return {
      province,
      city,
      county,
      isEdit: false,
      from: {
        source: "", // 预置密码字段，避免 v-model 报错
      },
      options: [
        {
          value: 1,
          label: "个人用户",
        },
        {
          value: 2,
          label: "校园用户",
        },
      ],
      cityOption: [],
      countyOption: [],
    };
  },
  computed: {
    // 映射 Vuex 中的用户信息，统一状态管理
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    const userInfo = this.userInfo;
    if (!userInfo || !userInfo.id) {
      this.$message.warning("您尚未登录，请先登录");
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
    }
  },
  watch: {
    // 监听 Vuex 的 userInfo，当数据就绪时，深拷贝给本地 from 表单
    userInfo: {
      handler(newVal) {
        if (newVal) {
          // 使用深拷贝，防止直接修改 Vuex 状态导致严格模式报错
          this.from = JSON.parse(JSON.stringify(newVal));
          // 如果返回的用户信息中没有 source 字段，手动添加空值
          if (!this.from.source) {
            this.from.source = "";
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    async memberListHandle() {
      let res = $user.memberList();
      console.log(res);
    },
    async sendOrderHandle() {
      let data = {
        id: 1,
        type: 1,
        noBill: true,
        email: "test@example.com",
      };
      let res = $user.payMember(data);
      console.log(res);
    },

    async submit() {
      // 1. 深拷贝一份表单数据，避免污染 Vuex 状态
      let payload = JSON.parse(JSON.stringify(this.from));

      // 2. 如果用户输入了新密码（非空），则映射为 password 字段
      if (payload.source && payload.source.trim() !== "") {
        payload.password = payload.source;
      }
      // 删除 source 字段，因为后端接口大概率不识别该字段
      delete payload.source;

      // 3. 发送请求
      let res = await $userInterface.updateUser2(payload);
      if (res.code === 0) {
        this.$message.success("修改成功");
        this.$store.commit("SET_USER_INFO", this.from);
        this.isEdit = false;
      } else {
        this.$message.error(res.msg || "修改失败");
      }
    },
    provinceChange(e) {
      this.cityOption = this.city[e];
      this.from.shi = "";
      this.from.xian = "";
    },
    cityChange(e) {
      this.countyOption = this.county[e];
      this.from.xian = "";
    },
    getShengName(id) {
      if (!id) return;
      let obj = this.province.find((item) => item.id === id);
      console.log(obj, 11);
      if (obj) {
        return obj.name;
      }
    },
    getShiName(id) {
      if (!id) return;
      let obj = this.city[this.from.sheng].find((item) => item.id === id);
      if (obj) {
        return obj.name;
      }
    },
    getXianName(id) {
      if (!id) return;
      let obj = this.county[this.from.shi].find((item) => item.id === id);
      if (obj) {
        return obj.name;
      }
    },
    edit() {
      this.isEdit = true;
      this.cityOption = this.city[this.from.sheng];
      this.countyOption = this.county[this.from.shi];
      // 确保密码字段存在，避免 v-model 值为 undefined
      if (!this.from.source) {
        this.from.source = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #fff;
  .content {
    width: 1420px;
    margin: 20px auto;
    color: #666;
    font-weight: 350;
  }
}
.avatar {
  width: 50%;
  text-align: center;
  > img {
    width: 460px;
    height: 460px;
    border-radius: 50%;
  }
}
</style>